import React, { createElement, useState, Fragment } from 'react';
import moduleCss from './index.module.scss';
import { Mask } from '@ifeng/lowcode_tool/src/components/Mask'
import { useChip, TYPE_Chip } from '@ifeng/lowcode_tool/src/hooks/useChip'
import { formatChip } from '@ifeng/lowcode_tool/src/method/chip'
import { getThumbnailFromRecommend } from '@ifeng/lowcode_tool/src/method/common'
import { formatImage } from '@ifeng/public_method'
import Chip from 'Chip';

export interface NewsList_3_Props {
    nodeId?: string
    newsChip: TYPE_Chip
    style?: object;
    isMore?: boolean // 初始值是 1+4（左边一个，右边4个），isMore 为 true 时，1+6
}

const NewsList_3: React.FC<NewsList_3_Props> = (props) => {
    const { nodeId, newsChip, style, isMore } = props;
    const [currentIndex, setCurrentIndex] = useState(0);

    const newsChipData = useChip(newsChip);
    const chipComponentData = formatChip(newsChip);

    return (
        <Chip {...chipComponentData}>
            <div id={nodeId} className={moduleCss.NewsList_3} style={style}>
                {newsChipData.length > 0 && (
                    <Fragment>
                        <div className={moduleCss.left}>
                            <img
                                src={formatImage(getThumbnailFromRecommend(newsChipData[0]), 303, 205)}
                                alt={newsChipData[0].title}
                            />
                            <a
                                className={moduleCss.title}
                                href={newsChipData[0].url}
                                target="_blank"
                                rel="noreferrer"
                            >
                                {newsChipData[0].title}
                            </a>
                            <div className={moduleCss.content}>
                                {newsChipData[0].summary}
                                <a
                                    className={moduleCss.cRed}
                                    href={newsChipData[0].url}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    [详细]
                                </a>
                            </div>
                        </div>
                        <div className={moduleCss.right}>
                            <div className={moduleCss.tabsWp}>
                                {newsChipData.slice(1,  isMore ? 4 : 3).map((item, index) => {
                                    return (
                                        <div
                                            className={`${moduleCss.tabs} ${isMore ? moduleCss.more : ''} ${index === 0 ? moduleCss.first : ''} ${index === currentIndex ? moduleCss.active : ''}`}
                                            key={index}
                                            onClick={() => setCurrentIndex(index)}
                                        >
                                            <div className={moduleCss.content}>
                                                <img
                                                    src={formatImage(getThumbnailFromRecommend(item), (isMore ? 200 :308) * 2, 130 * 2)}
                                                    alt={item.title}
                                                />
                                                <div className={moduleCss.title}>
                                                    <a href={item.url} target="_blank" rel="noreferrer">
                                                        {item.title}
                                                    </a>
                                                </div>
                                            </div>
                                            <img
                                                className={`${moduleCss.arrow} ${moduleCss.up}`}
                                                src="https://x2.ifengimg.com/fe/custom/meeting2022/arrow_up.60da33ab.jpg"
                                                alt="up"
                                            />
                                        </div>
                                    );
                                })}
                            </div>

                            <div className={moduleCss.center}>
                                <h2>{newsChipData.slice(1)[currentIndex].title}</h2>
                                <p>{newsChipData.slice(1)[currentIndex].summary}</p>
                            </div>

                            <div className={moduleCss.tabsWp}>
                                {newsChipData.slice(isMore ? 4 : 3, isMore ? 7 : 5).map((item, index) => {
                                    return (
                                        <div
                                            className={`${moduleCss.tabs} ${isMore ? moduleCss.more : ''} ${index === 0 ? moduleCss.first : ''} ${index + (isMore ? 3 : 2) === currentIndex ? moduleCss.active : ''}`}
                                            key={index}
                                            onClick={() => setCurrentIndex(index + (isMore ? 3 : 2))}
                                        >
                                            <img
                                                className={`${moduleCss.arrow} ${moduleCss.down}`}
                                                src={
                                                    'https://x2.ifengimg.com/fe/custom/meeting2022/arrow_down.19c2c9f1.jpg'
                                                }
                                                alt="down"
                                            />
                                            <div className={moduleCss.content}>
                                                <img
                                                    src={formatImage(getThumbnailFromRecommend(item), (isMore ? 200 :308) * 2, 130 * 2)}
                                                    alt={item.title}
                                                />
                                                <div className={moduleCss.title}>
                                                    <a href={item.url} target="_blank" rel="noreferrer">
                                                        {item.title}
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Fragment>
                )}
                <Mask visible={!newsChip.id} zIndex={3}>示例推荐位碎片—{newsChip.default.id}</Mask>
            </div>
        </Chip>

    );
};

export default NewsList_3;
